module.exports = __webpack_public_path__ + "static/media/MobileDataCYBERSEGURANÇAEATAQUESHACKERS.0ac73c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/cyberseguranca/MobileDataCYBERSEGURANÇAEATAQUESHACKERS.png
// module id = 102
// module chunks = 0